export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Arrow-Right-Gray-29f5df2830f833f4c851b3bc71a7e427.svg";